export enum ByTransactionCategoryEnum {
  uncategorized = 100,
  income = 1,
  taxes,
  internal_transfers,
  cash_checks,
  investment,
  savings_transfer,
  loan_payment,
  credit_card_payment,
  fees,
  entertainment,
  dining_drinks,
  groceries,
  shopping,
  software_tech,
  gifts,
  business,
  pets,
  home_garden,
  medical,
  health_wellness,
  personal_care,
  auto_transport,
  family_care,
  legal,
  education,
  charitable_donations,
  travel_vacation,
  bills_utilities,
  other = 99,
}
